import { render, staticRenderFns } from "./Debtors.vue?vue&type=template&id=428fcaea&scoped=true"
import script from "./Debtors.vue?vue&type=script&lang=js"
export * from "./Debtors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428fcaea",
  null
  
)

export default component.exports